import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import HouseFeatures from "@/components/builder/HouseFeatures.vue";
  import { formatPrice as formatMeters } from "@/helpers/transformation/price";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HouseNameAndFeatures',
  props: {
    houseInfo: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const house = ref(props.houseInfo);

  watch(
    () => props.houseInfo,
    (newhouseInfo, oldhouseInfo) => {
      if (newhouseInfo !== oldhouseInfo) {
        house.value = newhouseInfo;
      }
    }
  );

const __returned__ = { props, house, onMounted, ref, watch, get HouseDesignInterface() { return HouseDesignInterface }, HouseFeatures, get formatMeters() { return formatMeters } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})